<div class="animate-pulse">
  @if (showLoadingText) {
    <div class="text-lg" i18n>{{ loadingText }}</div>
  }

  @if (showTabs) {
    <ul
      class="!list-none flex flex-wrap space-y-2 md:space-y-0 bg-gray-100 sm:bg-transparent pt-4 sm:pt-0 rounded-t-lg"
      >
      @for (i of createArray(numberOfTabs); track i) {
        <li class="cursor-pointer mb-2">
          <div class="bg-gray-200 h-8 w-32 rounded-md"></div>
        </li>
      }
    </ul>
  }

  <div [class]="containerClass">
    <div [class]="gridClass">
      @for (i of createArray(numberOfCards); track i) {
        <div
          class="bg-gray-200 h-[280px] md:h-[312px] rounded-[12px]"
        ></div>
      }
    </div>
  </div>
</div>
